'use strict';

var _             = require('underscore');
var $             = require('jquery');
var Core          = require('../core/core.js');
// var TopNavVersion = require('./topnav__version.js');

/**
 * Creates a connection area in a menu
 *
 * @param {String} [options.target=.js-sitemenu__right]
 * @class
 */

class TopNavVersion extends Core {

    _defaults() {
        return {
            target: '.js-sitemenu__right'
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__topnav__version">
                <span class='js-version-message'></span>
                <span class='js-version-btn'></span>
            </div>
        `;

        super.render();

        $('.js-version-btn', this.$el).on('click', this._clicked);
        
    }

     _clicked(e){
         e.preventDefault();
         $(e.currentTarget).trigger('Cioui:VersionMessage:click', e);
     }

     setVersionButton(title, type) {
        $('.js-version-btn', this.$el).removeClass("editor__topnav__version__btn editor__topnav__version__btn--draft editor__topnav__version__btn--version");

        if(type == 'draft'){
            $('.js-version-btn', this.$el).html(title);
            $('.js-version-btn', this.$el).addClass("editor__topnav__version__btn editor__topnav__version__btn--draft");
        }else if(type == 'version'){
            $('.js-version-btn', this.$el).html(title);
            $('.js-version-btn', this.$el).addClass("editor__topnav__version__btn editor__topnav__version__btn--version");
        }
     }

     setVersionMessage(text) {
        $('.js-version-message', this.$el).removeClass("editor__topnav__version__message--draft editor__topnav__version__message--empty");
        $('.js-version-message', this.$el).html(text);

        if(text) {
            $('.js-version-message', this.$el).addClass("editor__topnav__version__message--draft");
        } else {
            $('.js-version-message', this.$el).addClass("editor__topnav__version__message--empty");
        }
    }
}
module.exports = TopNavVersion;